const StatusType = {
    ENABLED: Symbol("enabled"),
    BLOCKED: Symbol("blocked"),
};

export default StatusType;